// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V11H17.4458L15.425 14.2333L9.5598 6.41307L5.54623 11H2V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 13V22H22V13H18.5542L15.575 17.7667L9.4402 9.58693L6.45377 13H2Z"}}]};

const ActivityFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'activity-filled',
    ref,
    icon: element,
  },
));

ActivityFilledIcon.displayName = 'ActivityFilledIcon';

export default ActivityFilledIcon;
